"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _q = _interopRequireDefault(require("q"));

var _EmailConfirmBar = _interopRequireDefault(require("../views/EmailConfirmBar"));

var _VerificationEmailResentMessage = _interopRequireDefault(require("../views/VerificationEmailResentMessage"));

var _VerificationEmailResendError = _interopRequireDefault(require("../views/VerificationEmailResendError"));

var _DOMSelectors = require("../constants/DOMSelectors");

var _NavSibling = _interopRequireDefault(require("nav-helpers/NavSibling"));

var _NavInjector = _interopRequireDefault(require("nav-helpers/NavInjector"));

var _AlertStyleInjector = _interopRequireDefault(require("nav-helpers/AlertStyleInjector"));

function createNavSibling(email) {
  var confirmBar = document.createElement('div');
  confirmBar.id = _DOMSelectors.HUBSPOT_EMAIL_CONFIRM_BAR_ID;
  confirmBar.innerHTML = (0, _EmailConfirmBar.default)(email);
  return new _NavSibling.default({
    key: _DOMSelectors.HUBSPOT_EMAIL_CONFIRM_BAR_ID,
    element: confirmBar,
    isPriority: true
  });
}

var BaseEmailConfirmBarLoader =
/*#__PURE__*/
function () {
  function BaseEmailConfirmBarLoader() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, BaseEmailConfirmBarLoader);
    this.email = '';
    this.userId = null;
    this.isVerified = null;
    this.isVisible = false;
    this.hasResent = false;

    if (this.getRequiredData && typeof this.getRequiredData === 'function') {
      this.getRequiredData().then(this.initialize.bind(this)).done();
    } else if (opts && opts.hasOwnProperty('email') && opts.hasOwnProperty('isVerified')) {
      this.initialize(opts);
    }
  }

  (0, _createClass2.default)(BaseEmailConfirmBarLoader, [{
    key: "initialize",
    value: function initialize(_ref) {
      var email = _ref.email,
          isVerified = _ref.isVerified,
          userId = _ref.userId;
      this.setEmail(email);
      this.setUserId(userId);
      this.setIsVerified(isVerified);

      if (this.email && this.isVerified === false) {
        this.render();
      }
    }
  }, {
    key: "resendVerificationEmail",
    value: function resendVerificationEmail() {
      // Prevents duplicate requests from clicking the
      // resend link before the request resolves.
      if (this.hasResent) {
        return _q.default.Promise.resolve();
      }

      this.hasResent = true;
      return this.handleResend(this.userId);
    }
  }, {
    key: "handleResend",
    value: function handleResend() {
      throw new Error('IMPLEMENT handleResend');
    }
  }, {
    key: "bindEventListeners",
    value: function bindEventListeners() {
      var _this = this;

      var actionsContainer = document.getElementById(_DOMSelectors.EMAIL_CONFIRM_ACTIONS_ID);
      var resendButton = document.getElementById(_DOMSelectors.RESEND_VERIFICATION_EMAIL_BUTTON_ID);

      var setEmailSentMessage = function setEmailSentMessage() {
        if (actionsContainer) {
          actionsContainer.innerHTML = (0, _VerificationEmailResentMessage.default)();
        }
      };

      var setEmailSentErrorMessage = function setEmailSentErrorMessage() {
        if (actionsContainer) {
          actionsContainer.innerHTML = (0, _VerificationEmailResendError.default)();
        }
      };

      if (resendButton) {
        resendButton.addEventListener('click', function () {
          _this.resendVerificationEmail().then(setEmailSentMessage, setEmailSentErrorMessage).catch(setEmailSentErrorMessage).done();
        });
      }
    }
  }, {
    key: "setEmail",
    value: function setEmail(email) {
      this.email = email;
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.userId = userId;
    }
  }, {
    key: "setIsVerified",
    value: function setIsVerified(isVerified) {
      this.isVerified = isVerified;

      if (isVerified && this.isVisible) {
        this.remove();
      }
    }
  }, {
    key: "setIsVisible",
    value: function setIsVisible(isVisible) {
      this.isVisible = isVisible;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isVisible) return;

      _AlertStyleInjector.default.inject();

      var confirmBar = createNavSibling(this.email);

      _NavInjector.default.insertBefore(confirmBar);

      this.bindEventListeners();
      this.setIsVisible(true);
    }
  }, {
    key: "remove",
    value: function remove() {
      _NavInjector.default.remove(_DOMSelectors.HUBSPOT_EMAIL_CONFIRM_BAR_ID);

      this.setIsVisible(false);
    }
  }]);
  return BaseEmailConfirmBarLoader;
}();

var _default = BaseEmailConfirmBarLoader;
exports.default = _default;
module.exports = exports.default;